import { z } from "zod";
import { UserSchema } from "./User";

export const CreateUserRequestSchema = UserSchema.pick({
    accountId: true,
    name: true,
    email: true,
    password: true,
    phoneNumber: true,
    roleId: true,
})

export type CreateUserRequest = z.infer<typeof CreateUserRequestSchema>;